import { defineQuery } from 'next-sanity'
import { imageFields, inlineCtaFields } from '../atoms'

export const puzzlePiecesBlockFields = `
  _id,
  _type,
  title,
  pieces[]{
    title,
    subTitle,
    image {
      ${imageFields}
    },
    "CTA": cta {
      ${inlineCtaFields}
    },
    backgroundColor
  }
`

export const PUZZLE_PIECES_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "puzzle-pieces-block"][0]{
    ${puzzlePiecesBlockFields}
  }
`)
